
























































































































































import { Vue, Component } from 'vue-property-decorator';
import AdminProductCard from '../../components/admin/AdminProductCard.vue';
import brandModule from '../../store/modules/brand.module';
import Product from '../../common/model/Product';
import { ProductWrite } from '../../common/types';
import tagModule from '../../store/modules/tag.module';
import errorModule from '../../store/modules/error.module';
import { eventBus } from '../../main';
import { CREATE_PRODUCT } from '../../common/constants';
import Tag from '../../common/model/Tag';
import productModule from '../../store/modules/product.module';

@Component({
  components: {
    AdminProductCard,
  },
})
export default class AdminProductInformation extends Vue {
  newProductButtonPressed = false;

  newProduct: ProductWrite = {
    title: '',
    description: '',
    image: '',
    tags: [],
    brand_id: '',
  };

  itemsPerPageArray = [16, 24, 32];

  search = '';

  filter = {};

  sortDesc = false;

  page = 1;

  itemsPerPage = 16;

  selectedTag = '';

  productTags: Array<Tag> = [
    { title: 'All Tags', id: '' },
  ];

  brandModule = brandModule;

  get products(): Array<Product> {
    if (this.selectedTag) {
      return productModule.products.filter(
        (product: Product) => product.tags.filter(tag => tag.id === this.selectedTag).length > 0,
      )
    }
    return productModule.products;
  }

  get numberOfPages(): number {
    return Math.ceil(this.products.length / this.itemsPerPage)
  }

  get secondaryColor(): string {
    return '#000000';
  }

  async created(): Promise<void> {
    eventBus.$on(CREATE_PRODUCT, this.productCreated);
    // Fetch tags if there are none loaded in the state yet.
    if (tagModule.tags.length === 0) {
      await tagModule.fetchTags();
      if (errorModule.hasError) {
        errorModule.clearError();
      }
    }
    for (let productIndex = 0; productIndex < this.products.length; productIndex += 1) {
      const product = this.products[productIndex];
      this.productTags.push(...product.tags);
    }
  }

  productCreated(): void {
    this.newProductButtonPressed = false;
  }

  nextPage(): void {
    if (this.page + 1 <= this.numberOfPages) this.page += 1
  }

  formerPage(): void {
    if (this.page - 1 >= 1) this.page -= 1
  }

  updateItemsPerPage(number: number): void {
    this.itemsPerPage = number
  }
}
